<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Detalhes da Distribuição</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Acompanhe os detalhes da distribuição.
      </span>
      <div class="ms-auto my-auto">
        <router-link :to="`/distributions`" class="btn btn-link" title="Voltar">
          Voltar
        </router-link>
      </div>
    </div>
    <ul class="nav nav-tabs nav-tabs-highlight nav-justified">
      <li class="nav-item">
        <a
          href="#d-tab-abstract"
          class="nav-link active"
          data-bs-toggle="tab"
          aria-selected="true"
          title="Resumo da Distribuição"
          role="tab"
          @click="setSelectedTab('abstract')"
        >
          <div class="d-flex align-items-center">
            <i
              class="ph ph-globe-hemisphere-west ph-lg bg-primary text-primary bg-opacity-10 rounded p-2 me-3"
            />
            <div class="fw-semibold">Resumo</div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#d-tab-list"
          class="nav-link"
          data-bs-toggle="tab"
          aria-selected="true"
          title="Lista de Clientes"
          role="tab"
          @click="setSelectedTab('list')"
        >
          <div class="d-flex align-items-center">
            <i
              class="ph ph-list ph-lg bg-primary text-primary bg-opacity-10 rounded p-2 me-3"
            />
            <div class="fw-semibold">Lista de Clientes</div>
          </div>
        </a>
      </li>
    </ul>
    <div class="tab-content mt-2">
      <div
        id="d-tab-abstract"
        class="tab-pane fade active show"
        role="tabpanel"
      >
        <LoadingData v-if="isLoadingDistribution" />
        <DetailsDistribution
          v-if="!isLoadingDistribution && selectedTab === 'abstract'"
          :distribution="distribution"
          @getAllResorces="getAllResorces"
        />
      </div>
      <div id="d-tab-list" class="tab-pane fade" role="tabpanel">
        <ListUserDistributions
          v-if="!isLoadingListUser"
          v-show="selectedTab === 'list'"
          :userDistributions="listUserDistribution"
          @changeHideOrShow="changeHideOrShow"
          @reloadData="getListUserDistribution"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DetailsDistribution from '@/components/distributions/DetailsDistribution.vue'
import ListUserDistributions from '@/components/distributions/ListUserDistributions.vue'

export default {
  name: 'DistributionsDetails',

  components: {
    LoadingData,
    DetailsDistribution,
    ListUserDistributions,
  },

  data() {
    return {
      distributionId: this.$route.params.distributionId,
      selectedTab: 'abstract',
      isLoadingDistribution: true,
      isLoadingListUser: true,
      distribution: {},
      listUserDistribution: [],
    }
  },

  methods: {
    getAllResorces() {
      this.getDistribution()
      this.getListUserDistribution()
    },

    async getDistribution() {
      try {
        this.distribution = await this.$store.dispatch(
          'getDistribution',
          this.distributionId,
        )
        this.isLoadingDistribution = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getListUserDistribution() {
      try {
        this.listUserDistribution = await this.$store.dispatch(
          'getListUserDistribution',
          this.distributionId,
        )
        this.isLoadingListUser = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async changeHideOrShow(data) {
      try {
        const response = await this.$store.dispatch('updateUserDistribution', {
          id: this.distributionId,
          uuid: data.uuid,
          userDistribution: {
            hideOnReport: data.hideOnReport,
          },
        })
        if (response.status === true) {
          this.$root.$refs.notification.success(
            'Questionário atualizado com sucesso.',
          )
          // Troca o status do hideOnReport
          this.listUserDistribution = this.listUserDistribution.map((item) => {
            if (item.uuid === data.uuid) {
              return {
                ...item,
                hideOnReport: data.hideOnReport,
              }
            }
            return item
          })
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    setSelectedTab(tab) {
      this.selectedTab = tab
    },
  },

  mounted() {
    this.getDistribution()
    this.getListUserDistribution()
  },
}
</script>
